/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Record_Voiceover_Aria_LabelInputs */

const en_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record voiceover`)
};

const fr_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer une voix off`)
};

const de_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachaufnahme`)
};

const it_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra la voce fuori campo`)
};

const ru_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись закадрового голоса`)
};

const es_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grabar voz en off`)
};

const zh_cn2_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`录制旁白`)
};

const ja_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ナレーションを録音する`)
};

const hi_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वॉयसओवर रिकॉर्ड करें`)
};

const pt_pt2_event_ad_record_voiceover_aria_label = /** @type {(inputs: Event_Ad_Record_Voiceover_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gravar locução`)
};

/**
* | output |
* | --- |
* | "Record voiceover" |
*
* @param {Event_Ad_Record_Voiceover_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_record_voiceover_aria_label = /** @type {((inputs?: Event_Ad_Record_Voiceover_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Record_Voiceover_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_record_voiceover_aria_label(inputs)
	if (locale === "de") return de_event_ad_record_voiceover_aria_label(inputs)
	if (locale === "it") return it_event_ad_record_voiceover_aria_label(inputs)
	if (locale === "ru") return ru_event_ad_record_voiceover_aria_label(inputs)
	if (locale === "es") return es_event_ad_record_voiceover_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_record_voiceover_aria_label(inputs)
	if (locale === "ja") return ja_event_ad_record_voiceover_aria_label(inputs)
	if (locale === "hi") return hi_event_ad_record_voiceover_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_record_voiceover_aria_label(inputs)
	return en_event_ad_record_voiceover_aria_label(inputs)
});